import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './Flexmargin.scss';

const Flexmargin = ({ className, vertical }) =>
  (<div className={classNames(className, s.flexmargin, { [s.vertical]: vertical })} />);

Flexmargin.propTypes = {
  className: PropTypes.string,
  vertical: PropTypes.bool
};

Flexmargin.defaultProps = {
  className: '',
  vertical: false
};

export default Flexmargin;
